/* ==========================================================================
   <predictive-search> — canlı arama
   Shopify /search/suggest.json'u kullanır. Parça/OEM kodu paterni girilirse
   birebir eşleşmeleri "Parça kodu eşleşmesi" grubunda en üste taşır.
   ========================================================================== */
(function () {
  'use strict';

  const T = window.Theme || {};
  const L = window.predictiveStrings || {
    products: 'Ürünler',
    collections: 'Kategoriler',
    pages: 'Sayfalar',
    code_match: 'Parça kodu eşleşmesi',
    view_all: 'Tüm sonuçları gör',
    no_results: 'Sonuç bulunamadı',
  };

  const CODE_RE = /^[a-z0-9][a-z0-9.\-_/]{3,}$/i; // kod paterni: harf/rakam + . - _ /

  class PredictiveSearch extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('[data-predictive-input]');
      this.results = this.querySelector('[data-predictive-results]');
      this.status = this.querySelector('[data-predictive-status]');
      this.form = this.querySelector('form');
      this.minChars = 2;
      this.activeIndex = -1;
      this.reqId = 0; // istek sıra koruması (stale cevap engelleme)
    }

    connectedCallback() {
      if (!this.input || !this.results) return;
      const onInput = (T.debounce || debounceFallback)(() => this.onInput(), 140);
      this.input.addEventListener('input', onInput);
      this.input.addEventListener('focus', () => {
        if (this.input.value.trim().length >= this.minChars) this.open();
      });
      this.input.addEventListener('keydown', (e) => this.onKeydown(e));
      document.addEventListener('click', (e) => {
        if (!this.contains(e.target)) this.close();
      });
    }

    async onInput() {
      const q = this.input.value.trim();
      if (q.length < this.minChars) return this.close();
      const reqId = ++this.reqId; // bu isteğin sıra numarası
      try {
        const url =
          (T.routes && T.routes.predictive_search_url || '/search/suggest') +
          '.json?q=' + encodeURIComponent(q) +
          '&resources[type]=product,collection,page&resources[limit]=8&resources[options][unavailable_products]=last' +
          // Parça/OEM kodu araması: varsayılan alanlara SKU + barkod (OEM) eklenir
          '&resources[options][fields]=title,product_type,variants.title,variants.sku,variants.barcode,vendor';
        const res = await fetch(url);
        const data = await res.json();
        if (reqId !== this.reqId) return; // daha yeni bir istek var; bu eski cevabı yok say
        this.render(data.resources.results || {}, q);
      } catch (e) {
        if (reqId === this.reqId) this.close();
      }
    }

    render(r, q) {
      const products = r.products || [];
      const collections = r.collections || [];
      const pages = r.pages || [];

      // Parça kodu eşleşmesi tespiti
      let codeMatches = [];
      let restProducts = products;
      if (CODE_RE.test(q)) {
        const needle = normalizeCode(q);
        codeMatches = products.filter((p) =>
          normalizeCode((p.title || '') + ' ' + (p.sku || '')).includes(needle)
        );
        const codeIds = new Set(codeMatches.map((p) => p.id));
        restProducts = products.filter((p) => !codeIds.has(p.id));
      }

      let html = '<div class="predictive">';

      if (codeMatches.length) {
        html += group(L.code_match, codeMatches.map((p) => productItem(p, true)).join(''));
      }
      if (restProducts.length) {
        html += group(L.products, restProducts.map((p) => productItem(p)).join(''));
      }
      if (collections.length) {
        html += group(L.collections, collections.map((c) => linkItem(c)).join(''));
      }
      if (pages.length) {
        html += group(L.pages, pages.map((p) => linkItem(p)).join(''));
      }

      if (!products.length && !collections.length && !pages.length) {
        html += '<p class="predictive__empty">' + L.no_results + '</p>';
      } else {
        const searchUrl = (T.routes && T.routes.search_url || '/search') + '?q=' + encodeURIComponent(q) + '&type=product';
        html += '<a class="predictive__viewall" href="' + searchUrl + '">' + L.view_all + '</a>';
      }

      html += '</div>';
      this.results.innerHTML = html;
      this.activeIndex = -1;
      // Erişilebilirlik: her sonucu role=option + benzersiz id yap, durumu duyur
      const items = this.results.querySelectorAll('.predictive__item');
      items.forEach((el, i) => { el.setAttribute('role', 'option'); el.id = 'psi-' + i; });
      if (this.status) this.status.textContent = items.length + ' ' + (L.results_word || 'sonuç');
      this.open();
    }

    open() {
      this.results.hidden = false;
      if (this.input) this.input.setAttribute('aria-expanded', 'true');
    }
    close() {
      this.results.hidden = true;
      this.activeIndex = -1;
      if (this.input) {
        this.input.setAttribute('aria-expanded', 'false');
        this.input.removeAttribute('aria-activedescendant');
      }
    }

    onKeydown(e) {
      const items = Array.from(this.results.querySelectorAll('.predictive__item'));
      if (e.key === 'Escape') return this.close();
      if (!items.length) return;
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        this.activeIndex = Math.min(this.activeIndex + 1, items.length - 1);
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        this.activeIndex = Math.max(this.activeIndex - 1, 0);
      } else if (e.key === 'Enter') {
        if (this.activeIndex >= 0 && items[this.activeIndex]) {
          e.preventDefault();
          window.location = items[this.activeIndex].getAttribute('href');
        }
        return;
      } else {
        return;
      }
      items.forEach((it, i) => it.classList.toggle('is-active', i === this.activeIndex));
      const active = items[this.activeIndex];
      if (active) {
        active.scrollIntoView({ block: 'nearest' });
        if (this.input) this.input.setAttribute('aria-activedescendant', active.id);
      }
    }
  }

  function group(title, inner) {
    return '<div class="predictive__group"><p class="predictive__group-title">' + title + '</p>' + inner + '</div>';
  }

  function productItem(p, isCode) {
    const img = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
    const imgHtml = img ? '<img src="' + img + '" alt="" loading="lazy">' : '';
    const price = p.price ? '<span class="predictive__item-meta">' + formatMoney(p.price) + '</span>' : '';
    const vendor = p.vendor ? '<span class="predictive__item-meta">' + escapeHtml(p.vendor) + '</span>' : '';
    return (
      '<a class="predictive__item' + (isCode ? ' predictive__item--code' : '') + '" href="' + p.url + '">' +
      imgHtml +
      '<span class="predictive__item-body"><span class="predictive__item-title">' + escapeHtml(p.title) + '</span>' +
      '<span class="predictive__item-metaline">' + vendor + ' ' + price + '</span></span>' +
      '</a>'
    );
  }

  function linkItem(o) {
    return '<a class="predictive__item" href="' + o.url + '"><span class="predictive__item-title">' + escapeHtml(o.title) + '</span></a>';
  }

  function formatMoney(value) {
    // /search/suggest.json fiyatı string ("29.99") ya da kuruş olabilir; sade gösterim
    const num = typeof value === 'string' ? parseFloat(value) : value / 100;
    if (isNaN(num)) return '';
    try {
      return new Intl.NumberFormat('tr-TR', { style: 'currency', currency: window.shopCurrency || 'TRY' }).format(num);
    } catch (e) {
      return num.toFixed(2);
    }
  }

  function normalizeCode(s) {
    // Kod eşleştirme: boşluk/nokta/tire/altçizgi/slash duyarsız, büyük harf
    return String(s == null ? '' : s).toUpperCase().replace(/[\s.\-_/]+/g, '');
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  }

  function debounceFallback(fn, wait) {
    let t;
    return function () { clearTimeout(t); t = setTimeout(fn, wait); };
  }

  if (!customElements.get('predictive-search')) {
    customElements.define('predictive-search', PredictiveSearch);
  }
})();
